import styled from 'styled-components'

export const SidebarGroup = styled.div`
    border-radius:6px;
    background-color:#fff;
    border: 1px solid #C9C9C9;
  	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
`
export const SidebarSticky = styled.div`
    margin:0;
`

export const SidebarCard = styled.div`
    + .sidebar-card{
        .sidebar-cardbody{
            padding-top:0;
        }
    }
`
export const SidebarCardHeader = styled.div`
    position: relative;
    color:#000;
`
export const SidebarCardTitle = styled.div`
    position: relative;
    font-weight:700;
    font-size: 16px;
    line-height: 28px;
    margin-bottom:5px;
    color:#000;
    @media (min-width: 992px) {      
        font-size: 18px;
        line-height: 28px;
        margin-bottom:10px;
    }
    @media (min-width: 1200px) {
        font-size: 20px;
        line-height: 30px;
        margin-bottom:15px;
    }
`
export const SidebarCardBody = styled.div`
    padding:20px;
    @media(min-width:1200px){
        padding:25px;
    }
    @media(min-width:1600px){
        padding:30px;
    }
    
`

export  const SearchForm = styled.div`
  position: relative;
`;

export  const SearchResults = styled.div`
  position: absolute;
  display: ${(props) => props.display};
  padding: 20px;
  max-width: 380px;
  width:100%;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
  background: #ffffff;
  left:0;
  right: 0;
  top: 100%;
  z-index: 20;
  border-radius: 6px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);

  li {
    list-style: none;
    a {
      color: #000;
      &:hover {
        text-decoration: underline;
        color: #D7272C;
      }
    }
  }
`;